import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingSection = () => {
  const features = [
    "Full contact details (name, email, phone)",
    "Professional photo and complete profile",
    "Direct messaging capability",
    "Portfolio and work samples access",
    "Lifetime access to this candidate"
  ];

  return (
    <div className="bg-primary/5 rounded-xl p-6 mb-6 border border-primary/20">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-xl font-semibold text-foreground">Profile Unlock</h3>
          <p className="text-sm text-muted-foreground">
            Get complete access to candidate information
          </p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-bold text-primary">149 kr</div>
          <div className="text-sm text-muted-foreground">One-time payment</div>
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-foreground">What you'll get:</h4>
        {features?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-3">
            <Icon name="Check" size={16} className="text-success flex-shrink-0" />
            <span className="text-sm text-muted-foreground">{feature}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-primary/20">
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Shield" size={14} className="text-success" />
          <span>Secure payment • GDPR compliant • 30-day support</span>
        </div>
      </div>
    </div>
  );
};

export default PricingSection;